export const READING_PLANS = {
	enero: {
        "tema": {
            "en": "Childhood",
            "es": "La infancia"
        },
        "pregunta": {
            "en": "Stories that capture the curiosity, imagination and wonder of the first experiences of our lives and how these help us shape our worldview.",
            "es": "Relatos que capturan la curiosidad, la imaginación y el asombro que tienen las primeras experiencias de nuestra vida y cómo estas nos ayudan a moldear nuestra visión de mundo. "
        },
        "id_libros": [
            "MM2746",
            "MM2740",
            "MM2586"
        ]
    },
	febrero: {
		tema: {
			en: "Feeling and Speaking",
			es: "Sentir y decir",
		},
		pregunta: {
			en: "These stories invite us to create spaces to talk about fears, joys, and worries, and to understand that asking for help and talking about our emotions is an essential part of taking care of ourselves.",
			es: "Estas historias nos invitan a crear espacios para hablar sobre miedos, alegrías y preocupaciones, y entender que pedir ayuda y hablar sobre nuestras emociones es parte esencial de cuidarnos.",
		},
		id_libros: ["MM1090", "MM2501", "MM2193"],
	},
	marzo: {
		tema: {
			en: "Robots, Monsters, and Other Creatures",
			es: "Robots, monstruos y otras criaturas",
		},
		pregunta: {
			en: "These stories featured strange beings we don't know or can't quite understand, invite us to reflect on diversity, acceptance, and coexistence.",
			es: "Estos libros, protagonizados por seres extraños que no conocemos o no logramos entender del todo, nos invitan a reflexionar sobre la diversidad, la aceptación y la convivencia. ",
		},
		id_libros: ["MM0600", "MM2927", "MM3141"],
	},
	abril: {
		tema: {
			en: "Childhood and society",
			es: "Infancia y sociedad",
		},
		pregunta: {
			en: "An invitation to observe society from a child's perspective and how their point of view can change the way we understand our world.",
			es: "Una invitación a observar la sociedad desde una mirada infantil y cómo su perspectiva puede cambiar la forma que entendemos el mundo.",
		},
		id_libros: ["MM1923", "MM1250", "MM1608"],
	},
	mayo: {
		tema: {
			en: "Singing Words",
			es: "Palabras que se cantan",
		},
		pregunta: {
			en: "These books take us on a journey through the popular musical traditions of Latin America and show us how musicality strengthens listening, memory, and emotional connection, laying the foundation for engaging with reading.",
			es: "Estos libros nos dan un recorrido por la tradición popular musical de América Latina y nos muestran cómo la musicalidad fortalece la escucha, la memoria y el vínculo afectivo, sentando las bases para el encuentro con la lectura.",
		},
		id_libros: ["MM1319", "MM0582", "MM0970"],
	},
	junio: {
		tema: {
			en: "Go Team!",
			es: "¡Vamos equipo!",
		},
		pregunta: {
			en: "This summer, we celebrate the FIFA World Cup, an opportunity to remember that sports can help us discover skills, learn to face challenges, and collaborate with others to achieve common goals.",
			es: "En este verano celebramos la Copa Mundial de Fútbol, una oportunidad para recordar que los deportes nos pueden ayudar a descubrir habilidades, aprender a enfrentar retos y colaborar con otros para alcanzar objetivos comunes. ",
		},
		id_libros: ["MM2212", "MM1597", "MM3106"],
	},
	julio: {
		tema: {
			en: "Read to Laugh",
			es: "Leer para reír",
		},
		pregunta: {
			en: "Characters and stories brimming with humor that play with language, exaggerate reality, and invite you to expect the unexpected. An opportunity to laugh uncontrollably and see the world from a different perspective.",
			es: "Personajes e historias llenas de humor que juegan con el lenguaje, exageran la realidad y te invitan a esperar lo inesperado. Una oportunidad para reír sin control y mirar el mundo con otra perspectiva.",
		},
		id_libros: ["MM0812", "MM2754", "MM2742"],
	},
	agosto: {
		tema: {
			en: "Stories to Remember",
			es: "Historias para no olvidar",
		},
		pregunta: {
			en: "Through memories, stories, and anecdotes, these tales recover family memories, showing how the experiences of our grandparents continue to resonate with us.",
			es: "A través de recuerdos, relatos y anécdotas estas historias recuperan memorias familiares, mostrando cómo las experiencias de nuestras abuelas y abuelos siguen acompañándonos.",
		},
		id_libros: ["MM2842", "MM3010", "MM1314"],
	},
	septiembre: {
		tema: {
			en: "Latin America: Our Home",
			es: "Latinoamérica: nuestro hogar",
		},
		pregunta: {
			en: "These books explore the stories, flavors, landscapes, and cultures of Latin America, bringing us closer to the diverse voices, traditions, and memories that shape the identity of our continent.",
			es: "Estos libros recorren relatos, sabores, paisajes y culturas de América Latina, acercándonos a la diversidad de voces, tradiciones y memorias que conforman la identidad de nuestro continente.",
		},
		id_libros: ["MM1327", "MM2710", "MM0905"],
	},
	octubre: {
		tema: {
			en: "Music, Maestro!",
			es: "¡Música Maestro!",
		},
		pregunta: {
			en: "Music is much more than just sounds; it is also the emotions it evokes, the stories it tells, and the meaning it holds for the listener. These books invite us to discover, enjoy, and imagine all that music is and can be.",
			es: "La música es mucho más que sonidos, también es las emociones que genera, las historias que cuenta y el significado que cobra para quien la escucha. Estos libros nos invitan a conocer, disfrutar e imaginar todo lo que la música es y puede ser.",
		},
		id_libros: ["MM0542", "MM1612", "MM2875"],
	},
	noviembre: {
		tema: {
			en: "Heroes and Adventures",
			es: "Héroes y aventuras",
		},
		pregunta: {
			en: "Venture into these exciting stories where characters face challenges, overcome obstacles, and discover just how brave they can be.",
			es: "Aventúrate en estas emocionantes historias donde sus personajes tendrán que enfrentar retos, vencer desafíos y descubrir qué tan valientes son.",
		},
		id_libros: ["MM0848", "MM2812", "MM3050"],
	},
	diciembre: {
		tema: {
			en: "Recipes from Yesterday and Today",
			es: "Recetas de ayer y de hoy",
		},
		pregunta: {
			en: "Through out ingredients, dishes, and flavors, these books reveal conflicts, encounters, and memories, demonstrating that a good recipe is also a good story.",
			es: "A través de ingredientes, platos y sabores, estos libros nos muestran conflictos, encuentros y memorias, demostrando que una buena receta, es también una buena historia. ",
		},
		id_libros: ["MM2130", "MM2526", "MM3123"],
	},
	"enero_2027": {
		tema: {
			en: "Once upon this time",
			es: "Érase otra vez",
		},
		pregunta: {
			en: "These stories recapture the essence of classic tales and update them to resonate with new eras, perspectives, and readers, demonstrating that a good idea can become a thousand stories.",
			es: "Estas historias recuperan la esencia de relatos clásicos y los actualizan para dialogar con nuevas épocas, miradas y lectores, y nos demuestran que una buena idea puede convertirse en mil historias.",
		},
		id_libros: ["MM1572", "MM2940", "MM2104"],
	},
};

export const PAST_READING_PLANS = [
	{
		id: "2024",
		name: { default: "2024", translationPath: "" },
		file: {
			es: "/document/plan_lecturas_2024.pdf",
			en: "/document/plan_lecturas_2024_en.pdf",
		},
		img: "",
	},
	{
		id: "2023",
		name: { default: "2023", translationPath: "" },
		file: {
			es: "/document/plan_lecturas_2023_act.pdf",
			en: "/document/plan_lecturas_2023_act_en.pdf",
		},
		img: "/img/club-makemake/plan-lectura/2023.jpg",
	},
	{
		id: "2022",
		name: { default: "2022", translationPath: "" },
		file: {
			es: "/document/plan_lecturas_2022_act.pdf",
			en: "/document/plan_lecturas_2022_act_en.pdf",
		},
		img: "/img/club-makemake/plan-lectura/2022.jpg",
	},
	{
		id: "2021",
		name: { default: "2021", translationPath: "" },
		file: {
			es: "/document/plan_lecturas_2021_act.pdf",
			en: "/document/plan_lecturas_2021_act.pdf",
		},
		img: "/img/club-makemake/plan-lectura/2021.jpg",
	},
];

export const READING_PLAN_MONTHS = [
	{
		id: "enero",
		date: "2026-01-01",
		name: {
			default: "Enero",
			translationPath: "meses.enero",
		},
		visible: false,
	},
	{
		id: "febrero",
		date: "2026-02-01",
		name: {
			default: "Febrero",
			translationPath: "meses.febrero",
		},
		visible: true,
	},
	{
		id: "marzo",
		date: "2026-03-01",
		name: {
			default: "Marzo",
			translationPath: "meses.marzo",
		},
		visible: true,
	},
	{
		id: "abril",
		date: "2026-04-01",
		name: {
			default: "Abril",
			translationPath: "meses.abril",
		},
		visible: true,
	},
	{
		id: "mayo",
		date: "2026-05-01",
		name: {
			default: "Mayo",
			translationPath: "meses.mayo",
		},
		visible: true,
	},
	{
		id: "junio",
		date: "2026-06-01",
		name: {
			default: "Junio",
			translationPath: "meses.junio",
		},
		visible: true,
	},
	{
		id: "julio",
		date: "2026-07-01",
		name: {
			default: "Julio",
			translationPath: "meses.julio",
		},
		visible: true,
	},
	{
		id: "agosto",
		date: "2026-08-01",
		name: {
			default: "Agosto",
			translationPath: "meses.agosto",
		},
		visible: true,
	},
	{
		id: "septiembre",
		date: "2026-09-01",
		name: {
			default: "Septiembre",
			translationPath: "meses.septiembre",
		},
		visible: true,
	},
	{
		id: "octubre",
		date: "2026-10-01",
		name: {
			default: "Octubre",
			translationPath: "meses.octubre",
		},
		visible: true,
	},
	{
		id: "noviembre",
		date: "2026-11-01",
		name: {
			default: "Noviembre",
			translationPath: "meses.noviembre",
		},
		visible: true,
	},
	{
		id: "diciembre",
		date: "2026-12-01",
		name: {
			default: "Diciembre",
			translationPath: "meses.diciembre",
		},
		visible: true,
	},
	{
		id: "enero_2027",
		date: "2027-01-01",
		name: {
			default: "Enero 2027",
			translationPath: "meses.enero",
		},
		year: 2027,
		visible: true,
	},
];
